import { Component, Input, OnInit } from '@angular/core';
import { Instructions } from 'src/app/models/booking/instructions.model';
import { ServiceWrapperModel } from 'src/app/models/particle/service-wrapper.model';

@Component({
    selector: 'app-summary-delevery-instruction',
    templateUrl: './summary-delevery-instruction.component.html',
    styleUrls: ['./summary-delevery-instruction.component.scss'],
    standalone: false
})
export class SummaryDeleveryInstructionComponent implements OnInit {
  isShown = false;

  @Input() instructions: Instructions;

  constructor() { }

  ngOnInit(): void {
  }

  toggleShown() {
    this.isShown = !this.isShown;
  }

}
